<template>
  <ExistingItems :items="items" title="Φίλτρα Ομάδας">
    <template v-slot:item="props" v-if="items.length">
      <router-link
        :to="{
          name: 'products.filterGroups.filters.edit',
          params: {
            uuid: props.item.filter_group.uuid,
            filter: props.item.uuid,
          },
        }"
      >
        {{ props.item.title }}
      </router-link>
    </template>

    <p v-else>Δε βρέθηκαν αποτελέσματα</p>
  </ExistingItems>
</template>

<script>
import ExistingItems from '@/views/components/ExistingItems';

export default {
  components: {
    ExistingItems,
  },
  props: {
    items: Array,
    filterGroup: Object,
  },
};
</script>
